import React from 'react';
import { ArrowLeftIcon, LockIcon } from 'lucide-react';
import type { ResolvedBrand } from '../types/project';
import { SalesSourceLogo } from './SalesSourceLogo';
import { ThemeToggle } from './ThemeToggle';
interface TopBarProps {
  onLock: () => void;
  onBack?: () => void;
  brand?: ResolvedBrand | null;
}
export function TopBar({
  onLock,
  onBack,
  brand
}: TopBarProps) {
  const branded = Boolean(brand);
  const shellStyle = branded ? {
    backgroundColor: 'var(--b-surface)',
    borderColor: 'var(--b-border)',
    color: 'var(--b-text)'
  } : undefined;
  const buttonClass = branded ? 'inline-flex items-center gap-2 rounded-lg border border-[var(--b-border)] bg-[var(--b-surface-alt)] px-3 py-1.5 text-xs font-medium text-[var(--b-dim)] transition hover:border-[var(--b-accent)] hover:text-[var(--b-accent)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--b-accent)]' : 'inline-flex items-center gap-2 rounded-lg border border-shell-border bg-shell-surface px-3 py-1.5 text-xs font-medium text-shell-dim transition hover:border-accent hover:text-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-accent';
  return <header style={shellStyle} className={`sticky top-0 z-20 border-b ${branded ? '' : 'border-shell-border bg-shell-bg/90 backdrop-blur'}`} data-id="element-199" data-mp="3olc33p1dbzj5">
      <div className="mx-auto flex w-full max-w-6xl items-center gap-4 px-6 py-4" data-id="element-200" data-mp="3thkfiuo6lemm">
        {onBack ? <button type="button" onClick={onBack} className={buttonClass} data-id="element-201" data-mp="3jlpqnhtd6nbe">
            <ArrowLeftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-202" data-mp="3jjmoy0iun5qu" />
            All projects
          </button> : <SalesSourceLogo size={34} data-id="element-203" data-mp="3akrjiqnmpzol" />}

        <span className="ml-auto flex items-center gap-3" data-id="element-204" data-mp="3alkte0hvx5ay">
          {branded && <SalesSourceLogo size={26} withWordmark={false} data-id="element-205" data-mp="13ubn7jyltk31" />}
          <span className={`hidden font-mono text-[10px] uppercase tracking-[0.2em] sm:block ${branded ? 'text-[var(--b-dim)]' : 'text-shell-faint'}`} data-id="element-206" data-mp="13sqt1vg7c35p">
            Sales Source · Internal
          </span>
          <ThemeToggle branded={branded} data-id="element-207" data-mp="12cmpgm1dkv5a" />
        </span>

        <button type="button" onClick={onLock} className={buttonClass} data-id="element-208" data-mp="xe30sdved598">
          <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-209" data-mp="xgfj4s52hhmt" />
          Lock
        </button>
      </div>
    </header>;
}